import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import FounderDashboard from "./FounderDashboard";
import FinanceDashboard from "./FinanceDashboard";
import AdminDashboard from "./AdminDashboard";
import ParentDashboard from "./ParentDashboard";
import TeacherDashboard from "./TeacherDashboard";
import MonEspaceEleve from "./MonEspaceEleve";
import ScolariteDashboard from "./ScolariteDashboard";
import StaffDashboard from "./StaffDashboard";
import InfirmerieDashboard from "./InfirmerieDashboard";

export default function DashboardHome() {
  const { user } = useAuth();
  if (!user) return null;
  switch (user.role) {
    case "super_admin":
    case "founder":
      return <FounderDashboard />;
    case "finance":
      return <FinanceDashboard />;
    case "admin":
    case "director":
      return <AdminDashboard />;
    case "scolarite":
      return <ScolariteDashboard />;
    case "teacher":
      return <TeacherDashboard />;
    case "parent":
      return <ParentDashboard />;
    case "student":
      return <MonEspaceEleve />;
    case "nurse":
      return <InfirmerieDashboard />;
    case "staff":
      return <StaffDashboard />;
    default:
      // Tout profil professionnel inconnu (poste personnalisé) → espace Personnel, JAMAIS le portail Parent
      return <StaffDashboard />;
  }
}
